module.exports = __webpack_public_path__ + "img/no-image.d0d6eb4.webp";